/**
 * PIN Policy — Phase 5.2.
 *
 * Client-side mirror of apps/api/src/lib/parent-pin.ts PIN_POLICY.
 * Used to validate PIN inputs before sending to the server, and to
 * gate the number pad UI on input length.
 *
 * KEEP IN SYNC with the server. The server is the source of truth — this
 * file only mirrors the policy so the client can:
 *  - Disable "Lanjut" button until 4 digits entered
 *  - Show "PIN tidak valid" hint before sending (UX feedback)
 *  - Validate digit-only inputs
 */

export const PIN_POLICY = {
  LENGTH: 4,
  SESSION_TTL_MINUTES: 15,
  FORBIDDEN_PINS: [
    '0000', '1234', '4321',
    '1111', '2222', '3333', '4444', '5555',
    '6666', '7777', '8888', '9999',
  ],
  COOLDOWN_TIERS: [
    { failedAt: 3, seconds: 30 },
    { failedAt: 5, seconds: 300 },
    { failedAt: 10, seconds: -1 },
  ],
} as const;

export function isValidPinFormat(pin: string): boolean {
  if (pin.length !== PIN_POLICY.LENGTH) return false;
  if (!/^\d+$/.test(pin)) return false;
  return true;
}

export function isForbiddenPin(pin: string): boolean {
  return (PIN_POLICY.FORBIDDEN_PINS as readonly string[]).includes(pin);
}
